import { Link } from 'react-router-dom';
import GlassCard from '@/components/shared/GlassCard';

const NotFound = () => (
  <div className="flex flex-col gap-6">
    <div>
      <h1 className="text-4xl font-serif tracking-tight text-foreground">Not found</h1>
    </div>
    <GlassCard>
      <p className="text-sm text-muted-foreground">
        That route doesn&apos;t exist.{' '}
        <Link to="/" className="text-forest underline-offset-2 hover:underline">
          Back to Overview
        </Link>
        .
      </p>
    </GlassCard>
  </div>
);

export default NotFound;
